import { fetchMobileApp, updateMobileApp } from 'modules/mobileApps/actions';
import { getIsFetchingMobileApps, getMobileAppById } from 'modules/mobileApps/selectors';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { HeaderTitle, SecondaryPageHeader } from 'ui/pageHeader';
import { spacing } from 'ui/theme';
import { MobileApp, MobileAppsReducerState } from '../../types';
import { AppIcon } from '../AppIcon';
import { EmptyState } from '../EmptyState';
import { ConfigureAppForm } from './ConfigureAppForm';

const StyledHeaderTitle = styled(HeaderTitle)`
  display: flex;
  align-items: center;
  > *:first-child {
    margin-right: ${spacing.half};
  }
`;

export const EditApp = () => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const mobileApp = useSelector((state: { mobileApps: MobileAppsReducerState }) =>
    getMobileAppById(state, { id }),
  );
  const isFetchingApp = useSelector(getIsFetchingMobileApps);

  const handleUpdate = (app: MobileApp) => {
    dispatch(updateMobileApp(app));
  };

  useEffect(() => {
    dispatch(fetchMobileApp(parseInt(id, 10)));
  }, []);

  const [name, setName] = useState(mobileApp.name);
  const [platform, setPlatform] = useState(mobileApp.platform);
  const [packageName, setPackageName] = useState(mobileApp.packageName);
  const [storeUrl, setStoreUrl] = useState(mobileApp.storeUrl || '');

  const BREADCRUMB = {
    content: mobileApp.name,
    href: `/integrations/mobileApps/${id}`,
  };

  return isFetchingApp || !mobileApp.id ? (
    <EmptyState isLoading={isFetchingApp}>This app does not exist</EmptyState>
  ) : (
    <>
      <SecondaryPageHeader breadcrumb={BREADCRUMB}>
        <StyledHeaderTitle>
          <AppIcon platformType={mobileApp.platform} />
          {mobileApp.name}
        </StyledHeaderTitle>
      </SecondaryPageHeader>
      <ConfigureAppForm
        handleSubmit={() => handleUpdate({ ...mobileApp, name, platform, packageName, storeUrl })}
        mode="edit"
        name={name}
        onNameChange={(newName) => setName(newName)}
        onPackageNameChange={(newPackageName) => setPackageName(newPackageName)}
        onPlatformChange={(newPlatform) => setPlatform(newPlatform)}
        onStoreUrlChange={(newStoreUrl) => setStoreUrl(newStoreUrl)}
        packageName={packageName}
        platform={platform}
        storeUrl={storeUrl}
        submitButtonText="Update app"
      />
    </>
  );
};
